import { createApp, h } from "vue";
import { plugin, defaultConfig } from "@formkit/vue";
import vSelect from "vue-select";
import CKEditor from "@ckeditor/ckeditor5-vue";
import Builder from "./components/Builder";
import PageHeader from "./components/PageHeader";
import PageMaisons from "./components/PageMaisons";
import PageHotels from "./components/PageHotels";
import FormKitCKEditor from "../components/FormKitCKEditor";
import FormKitImage from "../components/FormKitImage";
import "vue-select/dist/vue-select.css";
import PageAlert from "./components/PageAlert";
import PageBanner from "./components/PageBanner";
import PageUsps from "./components/PageUsps";
import PageRegions from "./components/PageRegions";
import PageNewsletter from "./components/PageNewsletter";
import PageReviewSlider from "./components/PageReviewSlider";
import PageSearchHero from "./components/PageSearchHero";
import PageText from "./components/PageText";
import PageDoubleGrid from "./components/PageDoubleGrid";
import Draggable from "vuedraggable";
import VueMultiselect from "vue-multiselect";

import "vue-multiselect/dist/vue-multiselect.css";

const app = createApp({
    render: () => h(Builder, { initialComponents: window.json ?? [] }),
});

app.component("VSelect", vSelect);
app.component("Builder", Builder);
app.component("PageHeader", PageHeader);
app.component("PageMaisons", PageMaisons);
app.component("PageHotels", PageHotels);
app.component("PageAlert", PageAlert);
app.component("PageBanner", PageBanner);
app.component("PageUsps", PageUsps);
app.component("PageRegions", PageRegions);
app.component("FormKitCKEditor", FormKitCKEditor);
app.component("FormKitImage", FormKitImage);
app.component("PageNewsletter", PageNewsletter);
app.component("PageReviewSlider", PageReviewSlider);
app.component("PageSearchHero", PageSearchHero);
app.component("PageText", PageText);
app.component("PageDoubleGrid", PageDoubleGrid);
app.component('Draggable', Draggable);
app.component('VueMultiselect', VueMultiselect)

app.use(
    plugin,
    defaultConfig({
        props: {
            components: {
                type: Array,
                default: () => [],
            },
        },
        config: {
            classes: {
                input: ({ props }, input) => {
                    if (props.type === 'checkbox') {
                        return "d-block mr-3";
                    }

                    return "form-control";
                },
                wrapper: ({ props }, input) => {
                    if (props.type === 'checkbox') {
                        return "d-flex align-items-center";
                    }

                    return "form-group";
                },
            },
        },
    })
);

app.use(CKEditor);

app.mount("#page-builder");
